import { axios } from '@/utils/request'

export function fetchList (params) {
  return axios({
    url: '/sxNotice/page',
    method: 'GET',
    params: {
      ...params
    }
  })
}

export function getObj (id) {
  return axios({
    url: `/sxNotice/${id}`,
    method: 'GET'
  })
}

export function addObj (params) {
  return axios({
    url: `/sxNotice/save`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function putObj (params) {
  return axios({
    url: `/sxNotice/update`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function delObj (id) {
  return axios({
    url: `/sxNotice/${id}`,
    method: 'DELETE'
  })
}

export function addComment (params) {
  return axios({
    url: `/sxNotice/saveComment`,
    method: 'POST',
    data: {
      ...params
    }
  })
}

export function getNoticeList () {
  return axios({
    url: `/sxNotice/list`,
    method: 'GET'
  })
}
